<div class="mainContainer" [style.max-width]="maximumViewPortWidth">
    <div class="selectionContainer">

        <div class="timeSelection">
            <div>
                <label class="label-text">{{min}}hrs</label>
            </div>
             <div>
                <mat-slider 
                        class="slider"
                        [max]="max"
                        [min]="min"
                        [step]="step"
                        discrete
                        [showTickMarks]="showTicks">
                        <input 
                            matSliderThumb 
                            [(ngModel)]="sliderValue"
                            (ngModelChange)="onRangeChange($event)"
                         #slider>
                </mat-slider>
            </div>
            <div>
                <label class="label-text">{{max}}hrs</label>
            </div>
            <div class="line"></div>
            <div class="speed">
                <mat-form-field appearance="outline" class="speed-select">
                    <img matPrefix class="speedIcon" src="assets/library-icons/motion_photos_on.svg">
                    <mat-select [(ngModel)]="selectedSpeed"
                    (selectionChange)="onSpeedChange($event.value)"
                     panelClass="upward-dropdown">
                        
                        <mat-option *ngFor="let speed of  speeds" [value]="speed">
                        <div class="option-content">
                            <span>{{ speed }}</span>
                        </div>
                        </mat-option>

                    </mat-select>
                    </mat-form-field>
            


            
            </div>
            <div class="endDatePicker">
                <div
                class="datePickerTrigger"
                (click)="dateInput.showPicker()">
                <label class="endDatelabel">End Date: </label>
                <input
                    #dateInput
                    type="datetime-local"
                    class="datePicker"
                    [ngModel]="selectedEndDateString"
                    (ngModelChange)="onEndDateChange($event)"
                />

            </div>


        </div>
            
        </div>
        <div class="calendar">
            <div class="tickerTime">
                @if (tickerTimeZone) {
                  {{ formatTickerTime(pinnedPlayhead || currentTickerTime) }}
                } @else {
                  {{ (pinnedPlayhead || currentTickerTime) | date:'yyyy-MM-dd HH:mm:ss' }}
                }
            </div>
        </div>
        <button
            class="split-button"
            [ngClass]="splitEventLanes ? 'active': 'inactive'"
            (click)="splitEventLanes = !splitEventLanes">

            Split Events

            </button>
        <div class="line"></div>
        <div class="motionTags">
            


            <mat-select placeholder="Events"  [(ngModel)]="selectedMotions"
            (selectionChange)="onEventSelectionChange($event)"
            multiple>

            <mat-select-trigger class="main-select">
               
                Events     <span class="selected-number">{{selectedMotions.length}}</span> 
              
                  
            
                
            </mat-select-trigger>
                <!-- Options -->
            <mat-option *ngFor="let option of motionOptions" [value]="option.value">
            <div class="option-content">
                <span [style.color]="option.color">{{ option.label }}</span>
            </div>
            </mat-option>

            </mat-select>
        </div>

    </div>
 
<div class="timelineContainer" #timelineContainerRef>

    <div class="ticker">
        <span class="ticker-polygon">
            <img src="assets/library-icons/polygon.svg">
        </span>
    </div>

    <div class="timelineGrid">

        <!-- FIXED CAMERA COLUMN -->
        <div class="cameraColumn"
            [style.width.px]="cameraColumnWidth"
            [style.minWidth.px]="cameraColumnWidth">

            <!-- SCALE SPACER -->
            <div class="scaleNameSpacer"></div>

            <!-- CAMERA LABELS -->
            @for (cam of selectedCameraList; track cam.id; let i = $index) {
                <div class="cameraNameContainer">
                    {{cam.name}}
                </div>
            }

        </div>

        <!-- SCROLLABLE TIMELINE -->
        <div
            #timelineScroller
            class="timelineViewport"
            (wheel)="onWheelZoom($event)"
            (mousedown)="onDragStart($event)"
            (mousemove)="onDragMove($event)"
            (mouseup)="onDragEnd()"
            (mouseleave)="onDragEnd()"
        >

            <div class="timelineScroll">



                <!-- TIMELINE WORLD -->
                <div
                    class="timelineContent"
                    [style.width.px]="engine.getRenderWidth()"
                >

                    <!-- SCALE -->
                    <div class="scaleContainer">

                        <div
                            *ngFor="let tick of scaleTicks; trackBy: trackByIndex"
                            class="tick"
                            [class.major]="tick.type === 'major'"
                            [style.left.px]="tick.x"
                        >

                            <span
                                *ngIf="tick.type === 'major'"
                                class="tick-label"
                                [class.left]="tick.alignment === 'left'"
                                [class.right]="tick.alignment === 'right'"
                            >
                                {{ tick.label }}
                            </span>

                        </div>

                    </div>

                    <!-- CAMERA ROWS -->
                    @for (cam of selectedCameraList; track cam.id; let i = $index) {

                        <div class="timelineWrapper"  
                        [style.height.px]="
                        splitEventLanes
                        ? selectedMotionOptions.length * 18
                        : 34">

                            <div
                                class="timeLine"
                                [style.width.px]="engine.getRenderWidth()"
                            >

                                <div class="trackBackground"></div>

                            <ng-container
                            *ngFor="let motionType of selectedMotionOptions">

                            <div
                                *ngFor="let seg of cam?.segments?.[motionType.value]"
                                class="segment"
                                [ngStyle]="
                                    getCombinedSegmentStyles(
                                        seg,
                                        motionType.color,
                                        motionType.value,
                                        cam
                                    )"
                                (click)="onSegmentClick($event, seg, cam, motionType.value)">



                            </div>


                            </ng-container>

@if(activeTrimSelection?.camera?.id === cam.id){

<div
  class="trimSelection"
  [ngStyle]="getTrimSelectionStyles()">
</div>

<div
  class="trimHandle left"
  [ngStyle]="getTrimHandleStyles('left')"
  (mousedown)="onTrimHandleDown($event, 'left')">

  <div class="trimLine"></div>
  <div class="trimLabel">
    {{ activeTrimSelection?.trimStart | date:'HH:mm:ss' }}
  </div>
</div>

<div
  class="trimHandle right"
  [ngStyle]="getTrimHandleStyles('right')"
  (mousedown)="onTrimHandleDown($event, 'right')">

  <div class="trimLine"></div>
  <div class="trimLabel">
    {{ activeTrimSelection?.trimEnd | date:'HH:mm:ss' }}
  </div>
</div>




}

                            </div>

                        </div>

                    }

                </div>

                <!-- RIGHT SPACER -->
                <div
                    class="timelineSpacer"
                    [style.width.px]="viewportSpacer">
                </div>

            </div>

        </div>

    </div>

</div>

    <div class="actionContainer">
         @if(!trimMode){
        <span class="clip" (click)="onTrimClick()">
           
            <img class="action-buttons" src="assets/library-icons/scissors.svg" >&nbsp;Clip
          
        </span>
          }
        @else {
            <span class="clip" (click)="onTrimClose()">
                <img class="action-buttons" src="assets/library-icons/close.svg" >&nbsp;Cancel
            </span>
            <span class="clip" (click)="onDownloadSegmentClick()">
              <img class="action-buttons" src="assets/library-icons/save.svg" >&nbsp;Save
            </span>
        }
  
        <div class="actionCentre">
          
            <div class="frameControls">
                <img class="controlIcon" (click)="previousFrame()" src="assets/library-icons/skip_previous.svg">
                <span class="text">Frame</span>
                <img  class="controlIcon" (click)="nextFrame()" src="assets/library-icons/skip_next.svg">
            </div>
        
            <div class="moveControls">
                 <img class="controlIcon" (click)="skipBackward()" src="assets/library-icons/replay_10.svg">
                 @if(isPlaying){
                  <mat-icon class="controlIcon pauseIcon" (click)="onPause()">pause</mat-icon>
                 }@else {
                 <img class="controlIcon" (click)="onPlay()" src="assets/library-icons/play_arrow.svg">
                 }
                 <img class="controlIcon" (click)="skipForward()" src="assets/library-icons/forward_10.svg">
            </div>  
          
            <div class="eventControls">
                 <img class="controlIcon" (click)="previousEvent()" src="assets/library-icons/skip_previous.svg">
                 <span class="text">Event</span>
                 <img class="controlIcon"(click)="nextEvent()" src="assets/library-icons/skip_next.svg">
            </div>  
         

        </div>
    </div>

</div>

